import { setupWorker } from 'msw/browser'

// Handlers

import { handlerAppsCalendar } from '@db/apps/calendar/index'
import { handlerAppsCustomers } from '@db/apps/customers/index'
import { handlerAppsReserveList } from "@db/apps/reservelist/index"


const worker = setupWorker(
  ...handlerAppsCalendar,
  ...handlerAppsCustomers,
  ...handlerAppsReserveList,
)
export default function () {
  const workerUrl = `${import.meta.env.BASE_URL ?? '/'}mockServiceWorker.js`

  // worker.start({
  //   serviceWorker: {
  //     url: workerUrl,
  //   },
  //   onUnhandledRequest: 'bypass',
  // })
}
